import Operation from './operation';
import Wechat from './wechat';

export default [
    Operation,
    Wechat
];